import {ReportState, ShareStatus} from './Enums';
import {ReportShare, ReportVersion, User} from './index';

export class Report {
    ID: string;
    NAME: string;
    CREATED_BY: User;
    CREATED_DATE: string;
    LAST_UPDATED: string;
    STATE: ReportState;
    SHARE_STATUS: ShareStatus;
    ORG_SHARED: ShareStatus;
    SHARES: Array<ReportShare>
    LATEST: ReportVersion;

    UNLOCKED_AT: string;
    UNLOCKED_EXP: string;
    BASE_PRICE: number;

    PREPARED_FOR_ENTITY: string;
    PREPARED_FOR_ENTITY_ADDRESS: string;
    LOCKER_FOR: User;
    CURRENT_ALG_VERSION: string;

    static parse(json: any): Report {
        if (json) {
            const r = new Report();

            r.ID = json.ID;
            r.NAME = json.NAME;

            if (json.CREATED_BY)
                r.CREATED_BY = User.parse(json.CREATED_BY);

            r.CREATED_DATE = json.CREATED_DATE;
            r.LAST_UPDATED = json.LAST_UPDATED;

            r.STATE = ReportState[<string>json.STATE];

            r.SHARE_STATUS = ShareStatus[<string>json.SHARE_STATUS];
            r.ORG_SHARED = ShareStatus[<string>json.ORG_SHARED];

            if (json.LATEST)
                r.LATEST = ReportVersion.parse(json.LATEST);
            if (json.SHARES)
                r.SHARES = ReportShare.parseArray(json.SHARES);

            r.UNLOCKED_AT = json.UNLOCKED_AT;
            r.UNLOCKED_EXP = json.UNLOCKED_EXP;
            r.BASE_PRICE = json.BASE_PRICE;

            r.PREPARED_FOR_ENTITY = json.PREPARED_FOR_ENTITY;
            r.PREPARED_FOR_ENTITY_ADDRESS = json.PREPARED_FOR_ENTITY_ADDRESS;

            if (json.LOCKER_FOR)
                r.LOCKER_FOR = User.parse(json.LOCKER_FOR);

            r.CURRENT_ALG_VERSION = json.CURRENT_ALG_VERSION;

            return r;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<Report> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(Report.parse(j));

        return arr;
    }

    get isLocked(): boolean{
      return this.STATE === ReportState.LOCKED;
    }
}

export class ReportSummaryRequest {
    PAGE: number;
    SIZE: number;
    SORT: string;
    ORDER: string;
    QUERY: string;
    MODE: string;

    // helper
    escapedQuery: string = '';
    sort: string;

    static parse(json: any): ReportSummaryRequest {
        if (json) {
            const rsr = new ReportSummaryRequest();

            rsr.PAGE = json.PAGE;
            rsr.SIZE = json.SIZE;
            rsr.SORT = json.SORT;
            rsr.ORDER = json.ORDER;
            rsr.QUERY = json.QUERY;
            rsr.MODE = json.MODE;

            return rsr;
        } else return null;
    }
}
